import Rest2 from '../Services/Rest2'
import {store} from '../store/store'
/**
 * @typedef {WorkService}
 */
export default class WorkService{

    constructor() {
        this.resource = "/work"
        this.http = Rest2.build(store.getters.token, this.resource);
    }

    static build() {
        return new this();
    }

    getOne(id){
        return this.http.get(`/${id}`);
    }

    getAll(){
        return this.http.get('/all');
    }

    save_own_rights(params){
        return this.http.post('/save_own_rights',params)
    }
}